import HttpService from "./htttp.service";

class AddonService {

    /**
     * Fetch all available add-ons.
     */
    async fetchAddons() {
        try {
            const response = await HttpService.get("/addon");
            return response;
        } catch (error) {
            console.error("Error fetching add-ons:", error);
            throw error;
        }
    }

    /**
     * Purchase an add-on.
     * This would likely trigger a Stripe session or direct purchase.
     */
    async purchaseAddon(addonId) {
        try {
            const response = await HttpService.post("/addonbilling/purchase", { addonId });
            return response;
        } catch (error) {
            console.error("Error initiating addon purchase:", error);
            throw error;
        }
    }

    async getLatestAddonBilling() {
        try {
            const response = await HttpService.get("/addonbilling/latest");
            return response; // HttpService already unwraps data
        } catch (error) {
            console.error("Error fetching latest addon billing:", error);
            throw error;
        }
    }

    async updateAddonBilling(sessionId, updates) {
        try {
            const response = await HttpService.patch(`/addonbilling/${sessionId}`, updates);
            return response;
        } catch (error) {
            console.error("Error updating addon billing:", error);
            throw error;
        }
    }
}

export default new AddonService();
